import { Col, ConfigProvider, Form, Row } from "antd";
import Inputs from "../../../../biblio/Inputs/Inputs";
import Selects from "../../../../biblio/Selects/Selects";

interface ApplicantProps {
  identificationTypes: any;
  form: any;
}

const ApplicantForm = ({ identificationTypes }: ApplicantProps) => {
  return (
    <>
      <ConfigProvider direction="rtl">
        <div className="takaful--title-tabs-sub">
          <span>بيانات مقدم الطلب</span>
        </div>
        <Row gutter={16}>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="applicant_first_name"
              label="الاسم الأول"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              className="takaful--label-inputs"
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="applicant_father_name"
              label="إسم الأب"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="applicant_grandfather_name"
              label="إسم الجد"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="applicant_family_name"
              label="إسم العائلة"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="text" />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="applicant_identification_type_id"
              label="نوع الهوية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Selects options={identificationTypes.data} />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="applicant_identification_number"
              label="رقم الهوية"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
                {
                  len: 10,
                  message: "يجب أن يتكون رقم الهوية من 10 ارقام",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs type="tel" maxLength={10} />
            </Form.Item>
          </Col>
          <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
            <Form.Item
              name="applicant_phone"
              label="الهاتف"
              rules={[
                {
                  required: true,
                  message: "الرجاء تعبئة الحقل",
                },
                {
                  len: 10,
                  message: "يجب أن يتكون رقم الهاتف من 10 ارقام",
                },
              ]}
              labelCol={{ className: "takaful--label-style" }}
            >
              <Inputs placeholder="05XXXXXXXX" type="tel" maxLength={10} />
            </Form.Item>
          </Col>
        </Row>
      </ConfigProvider>
    </>
  );
};

export default ApplicantForm;
